<template>
	<div>
		<CCol md="12">
			<CRow
				align-vertical="center"
				class="form-group"
			>
				<CCol>
					<h4>
						Category
					</h4>
					<div v-show="label" class="category-label">
						{{ label }}
					</div>
				</CCol>
				<div class="px-3">
					<CButton
						block
						class="transparent"
						color="secondary"
						@click="handleEditCategory"
					>
						Edit categories
					</CButton>
				</div>
			</CRow>

			<CRow v-show="categories.length">
				<CCol>
					<div class="selected-categoies">
						<span
							v-for="(category, index) in categories"
							:key="index"
							class="category-item"
						>
							{{ category.name }}
						</span>
					</div>
				</CCol>
			</CRow>
		</CCol>

		<!-- Modal Section -->
		<ModalCategory
			ref="modal-category-selector-box"
			:selected-ids="localCategories"
			title="Available for categories"
			:is-require-select="isRequireSelect"
			@onSubmit="handleSubmitCategory"
		/>
	</div>
</template>

<script>
import { mapActions } from 'vuex';

import ModalCategory from '@/components/ModalCategory.vue';

import {
	cloneDeep,
} from '../assets/js/helpers';

export default {
	name: 'BaseCategorySelectorBox',

	components: {
		ModalCategory,
	},

	props: {
		categories: {
			type: Array,
			default: () => [],
		},
		label: {
			type: String,
			default: '',
		},
		invalidFeedback: {
			type: String,
			default: '',
		},
		isRequireSelect: {
			type: Boolean,
			default: false,
		},
	},

	data() {
		return {
			localCategories: [],
		};
	},

	methods: {
		...mapActions({
			preSelectCategories: 'categorySelector/preSelectCategories',
		}),
		handleEditCategory() {
			this.localCategories = cloneDeep(this.categories);
			this.preSelectCategories(this.localCategories.map((category) => category.id));
			this.$refs['modal-category-selector-box'].open();
		},

		handleSubmitCategory(categories = []) {
			this.localCategories = cloneDeep(categories);
			this.$emit('onSelected', cloneDeep(categories));
		},
	},
};
</script>

<style lang="scss" scoped>
.selected-categoies {
	display: flex;
	flex-flow: row wrap;
	gap: 8px;

	border: 1px solid $color-alto;
	border-radius: 4px;
	padding: 12px;

	.category-item {
		padding: 4px 12px;
		background-color: $color-gray-100;
		border-radius: 12px;
	}
}

.category-label {
	font-size: $font-size-caption;
	font-weight: $font-weight-semi-bold;
	color: #8c8c8c;
}
</style>